function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck
import { I18nManager } from 'react-native';
import { RtlFlexMap } from "./rtlFlexMap";

class RTLServiceStatic {
  /**
   * @returns true if it is Right-to-Left layout
   */
  isRTL() {
    return I18nManager.isRTL;
  }

  select(ltr, rtl) {
    return this.isRTL() ? rtl : ltr;
  }
  /**
   * Iterates through {RtlFlexMap} and reverses style values if needed.
   *
   * @param {ViewStyle} source - style to convert
   * @param {boolean} rtl - is layout currently in RTL mode (Needed for tests, because unable to mock this)
   *
   * @returns {ViewStyle} - style reversed to fit RTL
   */


  ignoreRTL(source, rtl = this.isRTL()) {
    const rtlStyle = Object.keys(RtlFlexMap).reduce((style, prop) => {
      const currentStyleValue = source[prop];

      if (currentStyleValue) {
        const i18nStyleValue = RtlFlexMap[prop].toRTL(currentStyleValue, rtl);
        return _objectSpread(_objectSpread({}, style), {}, {
          [prop]: i18nStyleValue
        });
      }

      return style;
    }, {});
    return _objectSpread(_objectSpread({}, source), rtlStyle);
  }

}

export const RTLService = new RTLServiceStatic();